<template>
    <div class="team-list-components">
        <div class="borad-operate-right">
            <div @click="gotoGroup" class="team-top flex justify-between items-center">
                <div>
                    <div class="team-title">{{ $t('Board.Team.title') }}</div>
                    <div class="team-desc">
                        {{ $t('Board.Team.no') }} {{ none }} {{ $t('Board.Team.festival') }}
                         / {{ $t('Board.Team.all') }} {{ total }} {{ $t('Board.Team.festival') }}
                    </div>
                </div>
                <div class="iconfont icon-fitness-jiantouyou more"></div>
            </div>
            <!-- 无数据状态 -->
            <div v-if="!list.length" class="team-content-none flex flex-column items-center">
                <div class="iconfont icon-fitness-meiyou-biaoqing none-data"></div>
                <div class="no-team">{{ $t('Board.Team.none') }}</div>
            </div>
            <!-- 有数据状态 -->
            <div class="team-content-have">
                <div
                    class="team-list flex items-center justify-between"
                    v-for="(item, index) in list"
                    @click="gotoDetails(item.id)"
                    :key="index">
                    <div class="flex items-center">
                        <p class="time">{{ item.lessonTime }}</p>
                        <div class="portrait relative">
                            <div
                                v-if="item.coachAvatar"
                                class="status-list-avatar"
                                :style="`background-image: url(${item.coachAvatar})`">
                            </div>
                            <img v-else src="../../../assets/images/saas-no-avatar.png" alt="100*100">
                        </div>
                        <div  class="team-name">
                            <p class="name">{{ item.coachNickname }}</p>
                            <p class="t">{{ item.lessonName }}</p>
                            <p class="t">{{ item.placeName }}</p>
                        </div>
                    </div>
                    <div
                        :class="item.statusCode == 1 ? '' : 'beIs'"
                        class="team-handle">
                        {{ item.statusName }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'team-list',
    components: {
    },
    data() {
        return {
            list: [],
            none: null,
            total: null,
            id: null,
        };
    },
    methods: {
        fetchData(id) {
            // 门店id
            this.id = id;
            API.get('lesson/team/schedule/dashboard', {
                params: {
                    storeId: id,
                },
            }).then(res => {
                this.none = res.notStartAmt;
                this.total = res.totalAmt;
                this.list = res.schedules;
            });
        },
        gotoGroup() {
            if (!this.$$filterPermission('课程-课程设置-查看团课课程列表')) {
                return this.$router.push('/403');
            }
            this.$router.push({
                name: 'Course',
                params: {
                    storeId: this.id,
                },
            });
        },
        gotoDetails(id) {
            if (!this.$$filterPermission('课程-课程设置-查看团课课程列表')) {
                return this.$router.push('/403');
            }
            this.$router.push({
                name: 'Course',
                params: {
                    scheduleId: id,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.team-list-components {
    width: 33%;
    height: 100%;
    margin-right: 1%;
    height: 490px;
}
.borad-operate-right {
    margin-right: 1%;
    width: 100%;
    height: 100%;
    padding: 20px 25px;
    background: #fff;
    border-radius: 7px;

    &:last-child {
        margin-right: 0;
    }
}
.team-title {
    font-size: 20px;
    color: #212121;
    font-weight: 400;
    margin-bottom: 4px;
}
.team-desc {
    font-size: 14px;
    color: #8b8b8b;
}
.team-content-have {
    margin-top: 10px;
}
.team-content-none {
    margin-top: 120px;

    .iconfont.none-data {
        font-size: 50px;
        color: #d8d8d8;
    }
}
.no-team {
    font-size: 15px;
    color: #999;
    margin-top: 20px;
}
.team-top {
    cursor: pointer;
}
.team-content-have {
    margin-top: 10px;
}
.team-list {
    width: calc(100% + 20px);
    padding: 15px 10px;
    border-radius: 8px;
    position: relative;
    left: -10px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 15px #77cef7;
        transition: box-shadow .5s;
    }

    .time {
        color: #8b8b8b;
        float: left;
        width: 50px;
        font-size: 13px;
    }
    .portrait {
        margin-right: 15px;
        img {
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
    }
    .team-name {
        font-size: 12px;
        color: #8b8b8b;

        .name {
            font-size: 14px;
            color: #212121;
        }
    }
    .rank {
        width: 30px;
        margin-right: 30px;
        text-align: center;

        .iconfont {
            color: #f2bd03;
            font-size: 25px;
        }
    }
    &:nth-child(2) {
        .iconfont {
            color: #b7b7b7;
        }
    }
    &:nth-child(3) {
        .iconfont {
            color: #f19a5b;
        }
    }
    .txt {
        color: #949494;
        font-size: 14px;
    }
    &:nth-child(4),
    &:nth-child(5) {
        .txt {
            font-size: 24px;
            color: #949494;
            font-style: italic;
        }
    }
}
.team-handle {
    background: #8dc5ff;
    width: 56px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 10px;
    color: #fff;
    border-radius: 12px;
}
.beIs {
    background: #f87e7e;
}
</style>
